// Fallback renderer for when SVG hasn't loaded yet or is missing
export const fallbackRenderer = (ctx: CanvasRenderingContext2D, color: string) => {
  ctx.beginPath();
  ctx.arc(0, 0, 3, 0, Math.PI * 2);
  ctx.fillStyle = color;
  ctx.globalAlpha = 0.3;
  ctx.fill();
  ctx.globalAlpha = 0.7;
  ctx.stroke();
};
